// @ts-strict-ignore
import Link from 'next/link'
import React from 'react'

import discount from '@/screens/Discount/page/ui/assets/discount.svg'
import service from '@/screens/Discount/page/ui/assets/service.svg'
import tool from '@/screens/Discount/page/ui/assets/trade-in.svg'
// import wallet from '@/screens/Discount/page/ui/assets/wallet.png'
import { DiscountCatalogItem } from '@/screens/Discount/page/ui/DiscountCatalogItem/DiscountCatalogItem'
import { useGetDiscountedProductsQuery } from '@/screens/Product/api/productApiSlice'

import { Col } from '@/shared/ui/Grid'
import { ItemType, TitleWithTriggers } from '@/shared/ui/TitleWithTriggers/TitleWithTriggers'

import styles from './styles.module.scss'

type DiscountTabProps = {
	KOD: string
}

const items: ItemType[] = [
	{
		type: 'icon',
		iconId: service,
		title: 'Гарантия',
		subtitle: '90 дней'
	},
	{
		type: 'icon',
		iconId: tool,
		title: 'Можно',
		subtitle: 'по обмену в Трейд-ин'
	},
	// {
	// 	type: 'image',
	// 	src: wallet as unknown as string,
	// 	alt: 'Яндекс сплит',
	// 	title: 'Яндекс',
	// 	subtitle: 'сплит'
	// },
	{
		type: 'icon',
		iconId: discount,
		title: 'Оплата по счёту',
		subtitle: 'для юр.лиц'
	}
]

export const DiscountTab = ({ KOD }: DiscountTabProps): JSX.Element => {
	const { data } = useGetDiscountedProductsQuery(KOD)

	const products = data?.data?.PRODUCTS
	const link = data?.data?.SECTION_LINK

	return (
		<section className={styles.root}>
			<div>
				<TitleWithTriggers nonTitle title="Проверенная б/у техника" items={items} />
				{!!products?.length &&
					products?.map(item => (
						<Col key={item.KOD + item.PART_NUMBER} span={24}>
							<DiscountCatalogItem showTip item={item} key={item.KOD + item.PART_NUMBER} />
						</Col>
					))}
			</div>
			{link && (
				<Link prefetch={false} href={link} className={styles.button} target="_blank">
					Все товары раздела
				</Link>
			)}
		</section>
	)
}
